import { cn } from '../utils'

interface AmbientBackgroundProps {
  variant?: 'full' | 'subtle'
  className?: string
}

export function AmbientBackground({ variant = 'full', className }: AmbientBackgroundProps) {
  if (variant === 'subtle') {
    return (
      <div
        className={cn('fixed inset-0 -z-10 overflow-hidden pointer-events-none', className)}
        aria-hidden
      >
        <div className="absolute top-[-20%] right-[-10%] w-[500px] h-[500px] rounded-full bg-brand-500/[0.04] blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-indigo-500/[0.03] blur-[100px]" />
      </div>
    )
  }

  return (
    <div
      className={cn('fixed inset-0 -z-10 overflow-hidden pointer-events-none', className)}
      aria-hidden
    >
      <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] rounded-full bg-brand-500/[0.07] blur-[120px]" />
      <div className="absolute top-[20%] right-[-15%] w-[500px] h-[500px] rounded-full bg-indigo-500/[0.06] blur-[100px]" />
      <div className="absolute bottom-[-10%] left-[30%] w-[400px] h-[400px] rounded-full bg-violet-500/[0.05] blur-[80px]" />
    </div>
  )
}
